import React, { useState, useEffect } from 'react';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonInput,
  IonItem,
  IonList,
  IonTextarea,
  IonButton,
  IonSelect,
  IonLabel,
  IonSelectOption,
  IonToast,
  IonText,
  IonAlert,
} from '@ionic/react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as actionCreator from '../store/actions/orderActions';
import _ from 'lodash';

const EditOrderContainer: React.FC = (props: any) => {
  const { list } = props;
  const { id } = useParams();
  const item = _.cloneDeep(_.find(list, { _id: id }));
  const [showAlert1, setShowAlert1] = useState<boolean>(false);

  const [customerName, setCustomerName] = useState<string>(item.customerName);
  const [customerNumber, setCustomerNumber] = useState<string>(
    item.customerNumber
  );
  const [deliveryLocation, setDeliveryLocation] = useState<string>(
    item.deliveryLocation
  );
  const [amountPaid, setAmountPaid] = useState<number>(item.amountPaid);
  const [orderDetails, setOrderDetails] = useState<string>(item.orderDetails);
  const [channel, setChannel] = useState<string>(item.channel);

  //handle toast
  const [showToast, setShowToast] = useState(false);
  if (props.updatedOrders === false) {
    setTimeout(() => setShowToast(true), 1000);
  }

  useEffect(() => {
    setCustomerName(item.customerName);
    setCustomerNumber(item.customerNumber);
    setDeliveryLocation(item.deliveryLocation);
    setAmountPaid(item.amountPaid);
    setOrderDetails(item.orderDetails);
    setChannel(item.channel);
    setShowToast(false);
  }, [
    id,
    item.amountPaid,
    item.channel,
    item.customerName,
    item.customerNumber,
    item.deliveryLocation,
    item.orderDetails,
  ]);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="dark">
          <IonTitle>Edit Order</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <p style={{ marginTop: '15vh' }}></p>

          <IonItem>
            <IonLabel position="stacked">
              Customer Name <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              value={customerName}
              onIonChange={(e) => setCustomerName(e.detail.value!)}
              clearInput
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">
              Customer Mobile Number <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              type="number"
              value={customerNumber}
              onIonChange={(e) => setCustomerNumber(e.detail.value!)}
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">
              Delivery To <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              value={deliveryLocation}
              onIonChange={(e) => setDeliveryLocation(e.detail.value!)}
              clearInput
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">
              Amount Paid <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              type="number"
              value={amountPaid}
              onIonChange={(e) => setAmountPaid(parseInt(e.detail.value!, 10))}
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">Order details</IonLabel>
            <IonTextarea
              value={orderDetails}
              onIonChange={(e) => setOrderDetails(e.detail.value!)}
            ></IonTextarea>
          </IonItem>

          <IonItem>
            <IonLabel>Channel</IonLabel>
            <IonSelect
              value={channel}
              placeholder="Select Channel"
              onIonChange={(e) => setChannel(e.detail.value)}
            >
              <IonSelectOption value="Instagram">Instagram</IonSelectOption>
              <IonSelectOption value="Facebook">Facebook</IonSelectOption>
              <IonSelectOption value="Online Shop">Online Shop</IonSelectOption>
            </IonSelect>
          </IonItem>

          <p style={{ marginTop: '5vh' }}></p>

          <IonButton
            expand="block"
            disabled={
              !(
                customerName &&
                customerNumber &&
                deliveryLocation &&
                amountPaid
              )
            }
            onClick={() =>
              props.onUpdateOrder({
                _id: id,
                customerName,
                customerNumber,
                deliveryLocation,
                amountPaid,
                orderDetails,
                channel,
                userId: props.user.email,
              })
            }
          >
            {props.info || 'Save Changes'}
          </IonButton>
          <IonButton expand="block" color="danger" routerLink="/orders">
            Cancel
          </IonButton>
        </IonList>
      </IonContent>
      <IonAlert
        isOpen={showAlert1}
        onDidDismiss={() => setShowAlert1(false)}
        header={`Delete Order?`}
        message={'This action can not be undone'}
        buttons={[
          'No',
          {
            text: 'Yes',
            handler: () =>
              props.onRemoveOrder({ orderId: id, userId: item.userId }),
          },
        ]}
      />

      <IonToast
        isOpen={showToast}
        message="Success."
        duration={3000}
        position="top"
      />
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    list: state.ordersReducer.list,
    info: state.ordersReducer.info,
    updatedOrders: state.ordersReducer.updatedOrders,
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onUpdateOrder: (payload: {}) =>
      dispatch(actionCreator.updateOrder(payload)),
    onRemoveOrder: (payload: {}) =>
      dispatch(actionCreator.removeOrder(payload)),
    onResetStatus: () => dispatch(actionCreator.resetStatus()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditOrderContainer);
